module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2020-09-04 at 22.44.18.04c2f4de.jpeg";